import React from 'react';
import Navigation from '../components/Navigation';
import Footer from '../components/Footer';
import MediaPress from '../components/MediaPress';
import SEO from '../components/SEO';

const MediaPage = () => {
  return (
    <div className="min-h-screen bg-white" data-testid="media-page">
      <SEO
        title="Media & Press Coverage"
        path="/media"
        description="Media coverage, news articles, YouTube interviews, and press features about Dr. Venkata Pradeep Babu Koyyala's work in oncology and community health."
        keywords="Dr Koyyala Media, Oncologist Interview, Cancer Awareness Video, ISMPO News, Medical Press Coverage"
      />
      <Navigation />
      <div className="pt-20">
        <MediaPress />
      </div>
      <Footer />
    </div>
  );
};

export default MediaPage;
